import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { CompanyService } from 'app/services/models/company.service';
import { PdfService } from 'app/services/models/pdf.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { TDocumentDefinitions } from 'pdfmake/interfaces';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-list-pdf',
  templateUrl: './list-pdf.component.html',
  styleUrls: ['./list-pdf.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ListPdfComponent implements OnInit {
  @BlockUI('section-block') blockUI: NgBlockUI;
  rows: any;
  public pageBasic = 1;  // Page number
  public selectedSize = 12;  // Items per page
  totalCount: number = 0;

  pdf: any = {};
  company: any = {};
  currentDate: string;


  constructor(private pdfService: PdfService, private toastrService: ToastrService, private router: Router, private companyService: CompanyService) {
    this.currentDate = new Date().toLocaleDateString();
  }

  async ngOnInit() {
    this.pdfService.event$.subscribe(async result => {
      await this.getAllPdfList(this.pageBasic - 1, this.selectedSize);
    });
    await this.getAllPdfList(this.pageBasic - 1, this.selectedSize);
  }

  async getAllPdfList(page: number, size: number) {
    this.blockUI.start();
    const data = await this.pdfService.getAllPdfsList(page, size);
    console.log(data);
    this.rows = data.pdfs;
    this.totalCount = data.totalCount;
    this.blockUI.stop();
  }

  async onPageChange(pageNumber: number) {
    this.pageBasic = pageNumber;
    await this.getAllPdfList(this.pageBasic - 1, this.selectedSize);
  }

  pdfBaslik = [
    { name: "Ürün adı", width: 200, isEye: true },
    { name: "Adet", width: 0, isEye: true },
    { name: "Fiyat", width: 0, isEye: true },
    { name: "Para Birimi", width: 0, isEye: true },
    { name: "Birim", width: 0, isEye: true },
  ];

  pdfUrunler = [
    { name: "Ürün 1 fsaf fsaf fsafa fsaf saf saf asf asfas fgasgagas asdasd", adet: "5", fiyat: "50", birimFiyat: "TL", birim: "Adet" },
    { name: "Ürün 2", adet: "6", fiyat: "45", birimFiyat: "EUR", birim: "KG" },
    { name: "Ürün 3", adet: "7", fiyat: "24", birimFiyat: "USD", birim: "GR" },
    { name: "Ürün 1", adet: "5", fiyat: "50", birimFiyat: "TL", birim: "Adet" },
    { name: "Ürün 2", adet: "6", fiyat: "45", birimFiyat: "EUR", birim: "KG" },
    { name: "Ürün 3", adet: "7", fiyat: "24", birimFiyat: "USD", birim: "GR" },
    { name: "Ürün 1", adet: "5", fiyat: "50", birimFiyat: "TL", birim: "Adet" },
    { name: "Ürün 2", adet: "6", fiyat: "45", birimFiyat: "EUR", birim: "KG" },

  ];

  async getByIdPdf(id) {
    const data = await this.pdfService.getByIdPdf(id);
    this.pdf = data;
    console.log(this.pdf);
    await this.getByIdCompany();
  }

  async getByIdCompany() {
    const data = await this.companyService.getByIdCompany(1);
    this.company = data;
    console.log(this.company)
  }

  async generatePDF(id) {
    await this.getByIdPdf(id);
    if (this.pdf != null) {
      const documentDefinition: TDocumentDefinitions = {
        content: [
          {
            columns: [
              //{ text: "Logo" }, buraya logo gelecek
              { text: this.pdf.title, style: 'header' },
            ],
            columnGap: 20,
  
          },
          {
            columns: [
              {
                width: 250,
                stack: [
                  { text: this.pdf.titleDescription, fontSize: 10 },
  
                ]
              }
            ]
          },
          {
            columns: [
              {
                stack: [
                  { text: "Teklif Verilen Şirket: Deneme", style: 'companyInfo' },
                  { text: "Sorumlu Kişi: Ali Veli", style: 'companyInfo' },
                  { text: "Telefon No: 4124124123", style: 'companyInfo' },
                  { text: "Adres: 1234 Elm Street, Suite 567, Metropolis, NY 12345", style: 'companyInfo' }
                ],
                width: '50%'
              },
              {
                stack: [
                  { text: `Tarih: ${this.currentDate}`, style: 'companyInfo', alignment: 'right' },
                  { text: "Teklif No: 2024-001", style: 'companyInfo', alignment: 'right' },
                  { text: "Ödeme: 30 Gün", style: 'companyInfo', alignment: 'right' }
                ],
                width: '50%'
              }
            ],
            columnGap: 20,
            margin: [0, 10, 0, 20]
          },
          { text: this.pdf.description ?? '' , margin:[0, 0, 0, 10] },
          {
            table: {
              widths: this.pdfBaslik.map(p => p.width || '*'),
              body: [
                this.pdfBaslik.map(title => ({ text: title.name, bold: true,fillColor: "#2980ba", color: "#ffffff"  })),
                ...this.pdfUrunler.map(urun => [
                  urun.name,
                  urun.adet,
                  urun.fiyat,
                  urun.birimFiyat,
                  urun.birim,
                ]),
              ],
            },
            layout: {
              fillColor: function (rowIndex: number, node: any, columnIndex: number) {
                return (rowIndex % 2 === 0) ? '#EAEAEA' : null;
              },
              hLineWidth: function () { return 0.5; },
              vLineWidth: function () { return 0.5; },
              hLineColor: function () { return 'black'; },
              vLineColor: function () { return 'black'; },
            }
          },
        ],
        footer: (currentPage, pageCount) => {
          return {
            stack: [
              { text: `Sayfa ${currentPage} / ${pageCount}`, alignment: 'center', margin: [0, 0, 0, 5] },
              { text: this.pdf.footer ?? '', alignment: 'center', margin: [0, 0, 0, 10] }
            ],
            style: 'footer',
            alignment: 'center'
          };
        },
        styles: {
          header: { fontSize: 16, bold: true, alignment: 'left' },
          date: { alignment: 'right' },
          contactInfo: {
            fontSize: 12,
            italics: true,
          },
          footer: { fontSize: 10, margin: [0, 0, 0, 0] },
          listStyle: {
            margin: [0, 0, 0, 20], // Alt margin ekleyebilirsiniz
            alignment: 'left' // Listenin hizalanması
          }
        },
        pageMargins: [40, 60, 40, 60]
      };
      pdfMake.createPdf(documentDefinition).open();
    }
  }

  createPdf() {
    this.router.navigate(['/admin/create-pdf']);
  }
}
